import { TextField } from '@mui/material';
import { useState } from 'react';

export type PriceInputProps = {
  disabled: boolean;
  onChange: (price: number) => void;
  error?: string;
  placeholder?: string;
};

export const PriceInput = (p: PriceInputProps) => {
  const [value, setValue] = useState<string>('');

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let inputValue = event.target.value;
    if (inputValue.endsWith(',')) {
      inputValue = inputValue.replace(',', '.');
    }
    inputValue = inputValue.replace(/[^0-9.]/g, '');
    inputValue = inputValue.replace(/\.{2,}/g, '.');
    const [int, decimal] = inputValue.split('.');
    if (decimal && decimal.length > 2) {
      return;
    }
    setValue(inputValue);
    p.onChange(parseFloat(inputValue));
  };

  return (
    <TextField
      data-testid="priceInput"
      value={value}
      disabled={p.disabled}
      error={!!p.error}
      helperText={p.error}
      placeholder={p.placeholder || ''}
      onChange={onChange}
      onWheel={(event) => {
        event.preventDefault();
      }}
      InputProps={{
        id: 'priceInput',
        sx: {
          input: {
            '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
              '-webkit-appearance': 'none',
            },
          },
        },
      }}
    />
  );
};
